import React from 'react';
import {StyleProp, View, ViewStyle} from 'react-native';
import Label from '../../Label';

interface HeaderProp {
  style?: StyleProp<ViewStyle>;
  isRenewal?: boolean;
}

export const Header = ({style = {}, isRenewal = false}: HeaderProp) => {
  return (
    <View style={style}>
      <Label
        title={`${
          isRenewal ? 'RENOUVELLEMENT' : 'SOUSCRIPTION'
        } Assurance Obsèques à Dago`}
        type="mainTitle"
      />
      <Label
        type="fourthTitle"
        title={
          "La souscription est uniquement disponible pour les résidents à l'étranger"
        }
      />
    </View>
  );
};
